// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n._t9ut15mc:focus-visible .frame-small-error-state, ._6w6f15mc:focus-visible div[data-smart-link-container]{outline:var(--ds-border-width-outline,2px) solid var(--ds-border-focused,#388bff)}\n._2hwxutpp{margin-right:var(--ds-space-150,9pt)}\n._2hwxze3t{margin-right:var(--ds-space-0,0)}._128m1o36:focus-visible{outline-width:medium}\n._mizu1r31:focus-visible{outline-color:currentColor}\n._ra3xglyw:focus-visible{outline-style:none}", ""]);
// Exports
module.exports = exports;
